import { Button, EButtonColorVariant, EButtonSizeVariant } from '@outdoorsyco/bonfire';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { useHostingRVFlow } from '@/components/route/become-a-host/RV/useHostingRVFlow';
import { useRouter } from '@/hooks/useRouter';
import { getUser } from '@/redux/selectors/auth/user';
import { trackNavClickedEvent } from '@/services/analytics/header';

export const GlobalHeaderBecomeHostButton = () => {
  const intl = useIntl();
  const router = useRouter();

  const user = useSelector(getUser);

  const { redirectToHostingRVFlow } = useHostingRVFlow();

  if (user?.owner) return null;

  if (router.pathname.startsWith('/become-a-host')) {
    return (
      <Button
        label={intl.formatMessage({
          id: 'PS0fm5',
          defaultMessage: 'Try hosting today',
          description: 'GlobalHeader > Become host button > Try hosting today',
        })}
        variant={EButtonColorVariant.Primary}
        size={EButtonSizeVariant.Medium}
        onClick={() => {
          trackNavClickedEvent({
            clickedLink: 'Try hosting today',
            isInDropdown: false,
          });
          redirectToHostingRVFlow();
        }}
      />
    );
  }

  return (
    <Button
      label={intl.formatMessage({
        id: '5oYshi',
        defaultMessage: 'Become a host',
        description: 'GlobalHeader > Become host button > Become a host',
      })}
      variant={EButtonColorVariant.Primary}
      size={EButtonSizeVariant.Medium}
      href="/become-a-host"
      onClick={() =>
        trackNavClickedEvent({
          clickedLink: 'Become a host',
          isInDropdown: false,
        })
      }
    />
  );
};
